import React from "react";
import { Link } from "react-router-dom";
import { BROWSER_ROUTES } from "@constants/browser.routes";
import { getCopyrightText } from "@components/Footer/utils/getCopyright";
import { useTranslation } from "react-i18next";
import { ENV } from "@config/env";

export const Footer: React.FC = React.memo(() => {
	const { t } = useTranslation();

	return (
		<>
			<footer className="footer-wrapper shell-offset bg-white border-t py-4 flex items-center justify-between text-sm transition-all duration-300 ease-in-out">
				<div className="text-gray-500">{getCopyrightText(t("psdaCommon.footer.copyright"), t("projectTitleSourceWP"))}{ENV.VERSION && <span className="ml-2 text-gray-400">{ENV.VERSION}</span>}</div>
				<div className="space-x-2">
					<Link to={BROWSER_ROUTES.PRIVACY_POLICY} className="text-primary hover:underline">
						{t("psdaCommon.footer.privacyPolicy")}
					</Link>
					<span className="text-gray-400">|</span>
					<Link to={BROWSER_ROUTES.TERMS_AND_CONDITIONS} className="text-primary hover:underline">
						{t("psdaCommon.footer.termsOfService")}
					</Link>
				</div>
			</footer>
		</>
	);
});
